module.exports = __webpack_public_path__ + "static/img/grupo-sin.d0db585.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/grupo-sin.png
// module id = 41
// module chunks = 6